import React, { useMemo } from "react";
import { McTable } from "@maersk-global/mds-react-wrapper/components-core/mc-table";

const JIRA_BASE_URL = "https://maersk-tools.atlassian.net/browse/";

const TAG_BASE =
  "display:inline-block;padding:2px 10px;border-radius:10px;font-size:12px;font-weight:600;white-space:nowrap;line-height:16px;";

const TAG_STYLES = {
  success: `${TAG_BASE}background-color:var(--mds_brand_appearance_success_weak_background-color,#d4edda);color:var(--mds_brand_appearance_success_weak_on-background-color,#155724);`,
  error: `${TAG_BASE}background-color:var(--mds_brand_appearance_error_weak_background-color,#fcdde0);color:var(--mds_brand_appearance_error_weak_on-background-color,#370005);`,
  warning: `${TAG_BASE}background-color:var(--mds_brand_appearance_warning_weak_background-color,#fff3cd);color:var(--mds_brand_appearance_warning_weak_on-background-color,#856404);`,
  neutral: `${TAG_BASE}background-color:var(--mds_brand_appearance_neutral_weakest_background-color,#f7f7f7);color:var(--mds_brand_appearance_neutral_weakest_on-background-color,#616161);`,
};

const JIRA_COLUMNS = [
  {
    id: "jiraid",
    label: "Jira ID",
    noWrap: true,
    cellTemplate: (e) =>
      e.html`<a href="${JIRA_BASE_URL}${e.rowData.jiraid}" target="_blank" rel="noopener noreferrer" style="color:#141414;text-decoration:underline;">${e.rowData.jiraid}</a>`,
  },
  { id: "description", label: "Summary" },
  { id: "assignee", label: "Assigned To" },
  { id: "platformPortfolio", label: "Portfolio" },
  { id: "jiraPlatform", label: "Platform" },
  { id: "jiraProduct", label: "Product" },
  { id: "horizontalVerticalFix", label: "Fix Type" },
  {
    id: "status",
    label: "Status",
    noWrap: true,
    cellTemplate: (e) =>
      e.html`<span style="${TAG_STYLES[e.rowData.statusAppearance] || TAG_STYLES.neutral}">${e.rowData.status}</span>`,
  },
  { id: "duedate", label: "Due Date", noWrap: true },
];

function getStatusAppearance(status, duedate) {
  const s = status?.toLowerCase();
  if (s === "done" || s === "closed") return "success";
  if (duedate) {
    const due = new Date(duedate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (due < today) return "error";
  }
  return "warning";
}

function JiraSection({ data, images, requiredForModal }) {
  const tableData = useMemo(
    () =>
      (data || []).map((ticket, index) => ({
        id: index,
        jiraid: ticket.jiraid[0],
        description: ticket.description || "",
        assignee: ticket.assignee || "",
        platformPortfolio: ticket.platformPortfolio || "",
        jiraPlatform: ticket.jiraPlatform || "-",
        jiraProduct: ticket.jiraProduct || "-",
        horizontalVerticalFix: ticket.horizontalVerticalFix || "-",
        status: ticket.status || "-",
        statusAppearance: getStatusAppearance(ticket.status, ticket.duedate),
        duedate: ticket.duedate || "",
      })),
    [data]
  );

  return (
    <div style={{ padding: requiredForModal ? "20px" : undefined }}>
      {data && data.length > 0 ? (
        <>
          <McTable data={tableData} columns={JIRA_COLUMNS} fit="small" caption="Jira Tickets" />
          {images && images.length > 0 && (
            <div className="report-images">
              {images.map((image, index) => (
                <img key={index} alt={image.name} src={image.preview} />
              ))}
            </div>
          )}
        </>
      ) : (
        <>
          <p className="report-subsection-header">Jira Tickets</p>
          <div className="report-content-box is-empty">NA</div>
        </>
      )}
    </div>
  );
}

export default JiraSection;
